module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingCreateorganization.05750073.png";